export default __webpack_public_path__ + "static/media/sugar1.d63568c8.jpeg";